import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface SupportContextType {
  isOpen: boolean;
  openSupport: () => void;
  closeSupport: () => void;
}

const SupportContext = createContext<SupportContextType | undefined>(undefined);

export function useSupportContext() {
  const context = useContext(SupportContext);
  if (!context) {
    throw new Error('useSupportContext must be used within a SupportProvider');
  }
  return context;
}

export const SupportProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openSupport = useCallback(() => setIsOpen(true), []);
  const closeSupport = useCallback(() => setIsOpen(false), []);

  return (
    <SupportContext.Provider value={{ isOpen, openSupport, closeSupport }}>
      {children}
    </SupportContext.Provider>
  );
};
